<div *ngIf="currentSettings else loading">
    <h2>{{ 'MODALS.HEADERS.USER_SETTINGS' | translate }}</h2>

    <div *ngIf="board">
        <label class="form-label" for="customRange2">
            <strong>{{ 'MODALS.FIELDS.COLUMN_SIZE' | translate }}</strong>
        </label>
        <input #sizeRange
               (change)="rangeValue = sizeRange.valueAsNumber"
               [value]="rangeValue"
               class="form-range"
               id="customRange2"
               max="2"
               min="0"
               style="width: 90%; margin-left: 5%"
               type="range"
        >
        <div style="margin-bottom: 15px; display: flex; justify-content: space-between">
            <span>{{ 'MODALS.FIELDS.SELECT.COLUMN_SIZE.LITTLE' | translate }}</span>
            <span>{{ 'MODALS.FIELDS.SELECT.COLUMN_SIZE.MIDDLE' | translate }}</span>
            <span>{{ 'MODALS.FIELDS.SELECT.COLUMN_SIZE.BIG' | translate }}</span>
        </div>
    </div>

    <div class="super__tabs">
        <div (click)="changeTab('board_statuses')"
             *ngIf="board"
             [class.active]="tab === 'board_statuses'"
             class="super__tabs tab"
             data-action="board_statuses">
            <span>{{ 'MODALS.TEXT.STATUS_BP' | translate }}</span>
        </div>
        <div (click)="changeTab('board')"
             *ngIf="board"
             [class.active]="tab === 'board'"
             class="super__tabs tab"
             data-action="board">
            <span>{{ 'MODALS.TEXT.FIELDS_BP' | translate }}</span>
        </div>
        <div (click)="changeTab('tasks_all_boards')"
             *ngIf="!board"
             [class.active]="tab === 'tasks_all_boards'"
             class="super__tabs tab"
             data-action="tasks_all_boards">
            <span>{{ 'MODALS.TEXT.ALL_FIELDS' | translate }}</span>
        </div>
    </div>

    <div class="tab__content">
        <ng-container *ngIf="tab === 'board_statuses'">
            <ng-container *ngTemplateOutlet="boardStatuses"></ng-container>
        </ng-container>
        <ng-container *ngIf="tab === 'board' || tab === 'tasks_all_boards'">
            <ng-container *ngTemplateOutlet="colonsSetting"></ng-container>
        </ng-container>
    </div>

    <ng-template #boardStatuses>
        <small>* {{ 'MODALS.TEXT.HIDE_STATUS' | translate }}</small>

        <div (cdkDropListDropped)="updateAfterDrag($event)"
             cdkDropList
             class="status_container list-group">
            <a *ngFor="let setting of currentSettings"
               [cdkDragBoundary]="'.status_container'"
               [cdkDragData]="setting"
               [cdkDragStartDelay]="100"
               cdkDrag
               class="list-group-item list-group-item-action"
            >
                <div style="width: 70%;">
                    <i class="{{setting.model.data.svg.class}}"
                       style="margin-right: 5px; font-size: 20px;"
                    ></i>
                    {{ setting.model.label }}
                </div>

                <div (click)="setting.hidden = !setting.hidden"
                     style="display: block ruby; cursor: pointer"
                >
                    <span [class]="setting.hidden ? 'text-secondary' : 'text-success'">
                        <i [class]="setting.hidden ? 'bi bi-eye-slash-fill' : 'bi bi-eye-fill'"></i>
                        {{ (setting.hidden ? 'MODALS.TEXT.STATUS_HIDDEN' : 'MODALS.TEXT.STATUS_VISIBLE') | translate }}
                    </span>
                </div>
            </a>
        </div>
    </ng-template>

    <ng-template #colonsSetting>
        <div (cdkDropListDropped)="updateAfterDrag($event)"
             cdkDropList
             class="status_container list-group">
            <a *ngFor="let setting of currentSettings"
               [cdkDragBoundary]="'.status_container'"
               [cdkDragData]="setting"
               [cdkDragStartDelay]="100"
               cdkDrag
               class="list-group-item list-group-item-action"
            >
                <div style="width: 70%;">
                    {{ setting.model ? setting.name : 'TASKS.TITLES.' + setting.alias | translate }}
                </div>

                <div (click)="changeHidden(setting)"
                     style="display: block ruby; cursor: pointer"
                >
                    <span [class]="setting.hidden ? 'text-secondary' : 'text-success'">
                        <i [class]="setting.hidden ? 'bi bi-eye-slash-fill' : 'bi bi-eye-fill'"></i>
                        {{ (setting.hidden ? 'MODALS.TEXT.COLUMN_HIDDEN' : 'MODALS.TEXT.COLUMN_VISIBLE') | translate }}
                    </span>
                </div>
            </a>
        </div>
    </ng-template>

    <button (click)="saveMemberSettings()"
            [disabled]="isLockButton"
            class="btn btn-block btn-success"
    >
        <span *ngIf="!isLockButton else refresh">
            {{ 'MODALS.BUTTONS.SAVE' | translate }}
        </span>
    </button>
</div>

<ng-template #loading>
    <app-component-loading></app-component-loading>
</ng-template>

<ng-template #refresh>
    <app-component-loading size="inline"></app-component-loading>
</ng-template>
